import styled from '@emotion/styled';
import { Card } from '@mui/material';

export const StyledEmployeesCard = styled(Card)`
  border-radius: 1.25rem;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.1);
`;
